export const initColumns = [
  {
    title: '医生ID',
    dataIndex: 'doctorId',
    width: 100
  },
  {
    title: '医生姓名',
    dataIndex: 'doctorName',
    width: 100
  },
  {
    title: '科室',
    dataIndex: 'deptName',
    width: 150
  },
  {
    title: '职业',
    dataIndex: 'careerTypeStr',
    width: 150
  },
  {
    title: '医生手机号码',
    dataIndex: 'doctorPhone',
    width: 150,
    slots: { customRender: 'doctorPhone' }
  },
  {
    title: '绑定患者人数',
    dataIndex: 'boundPatientNum',
    width: 100,
    slots: { customRender: 'boundPatientNum' },
    sorter: true
  },
  {
    title: '注册时间',
    dataIndex: 'createAt',
    width: 150,
    sorter: true
  },
  {
    title: '绑定BD',
    dataIndex: 'bdName',
    width: 100
  },
  {
    title: 'BD手机号码',
    dataIndex: 'bdPhone',
    width: 150,
    slots: { customRender: 'bdPhone' }
  },
  {
    title: '认证状态',
    dataIndex: 'statusStr',
    width: 130,
    slots: { customRender: 'statusStr' }
  },
  {
    title: '备案状态',
    dataIndex: 'recordStatusStr',
    width: 130,
    slots: { customRender: 'recordStatusStr' }
  },
  {
    title: '注销状态',
    dataIndex: 'isCancelStr',
    width: 100,
    slots: { customRender: 'isCancelStr' }
  },
  {
    title: '执业机构',
    dataIndex: 'hospitalName',
    width: 150
  },
  // {
  //   title: '所属互联网医院',
  //   dataIndex: 'agencyName',
  //   width: 150
  // },
  // {
  //   title: '绑定学生人数',
  //   dataIndex: 'boundStudentNum',
  //   width: 100
  // },
  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    fixed: 'right',
    width: 300,
    slots: { customRender: 'handle' }
  }
]
export const paginationConfig = {
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
}
// 备案状态
export const recordStatusMap = [
  {
    value: 0,
    label: '未申请备案',
    color: {
      color: '#1677FF',
      bg: '#E6F4FF',
      bc: '#BAE0FF'
    }
  },
  {
    value: 1,
    label: '备案审核中',
    color: {
      color: '#FFA940',
      bg: '#ffa9401a',
      bc: '#ffa9404d'
    }
  },
  {
    value: 2,
    label: '备案成功',
    color: {
      color: '#1FB5AB',
      bg: '#1fb5ab1a',
      bc: '#1fb5ab4d'
    }
  },
  {
    value: 3,
    label: '备案失败',
    color: {
      color: '#FF4D4F',
      bg: '#FFF1F0',
      bc: '#FFCCC7'
    }
  },
  {
    value: 4,
    label: '要求备案',
    color: {
      color: '#1677FF',
      bg: '#E6F4FF',
      bc: '#BAE0FF'
    }
  }
]
// 注销状态
export const logOffStatusMap = [
  {
    value: 0,
    label: '否',
    color: '#CCCCCC'
  },
  {
    value: 1,
    label: '是',
    color: '#FF4D4F'
  }
]
// 认证状态
export const anthStatusMap = [
  {
    value: 0,
    label: '待审核',
    color: {
      color: '#FFA940',
      bg: '#ffa9401a',
      bc: '#ffa9404d'
    }
  },
  {
    value: 1,
    label: '已认证',
    color: {
      color: '#1FB5AB',
      bg: '#1fb5ab1a',
      bc: '#1fb5ab4d'
    }
  },
  {
    value: 2,
    label: '未通过',
    color: {
      color: '#FF4D4F',
      bg: '#FFF1F0',
      bc: '#FFCCC7'
    }
  },
  {
    value: 3,
    label: '再次申请认证',
    color: {
      color: '#1677FF',
      bg: '#E6F4FF',
      bc: '#BAE0FF'
    }
  },
  {
    value: 4,
    label: '未提交资料',
    color: {
      color: '#1677FF',
      bg: '#E6F4FF',
      bc: '#BAE0FF'
    }
  },
  {
    value: 5,
    label: '资料不完善',
    color: {
      color: '#1677FF',
      bg: '#E6F4FF',
      bc: '#BAE0FF'
    }
  }
]
